import _ from 'lodash';

import * as constants from './AI.constants';
import * as services from './AI.service';

const state = {
  res_search: {},

  selectedBulletId: -1,

  isRequest: false,
};

const mutations = {
  [constants.SET_MAKE_AI_SEARCH_SUCCESS](state, res_search) {
    if (undefined !== res_search && null !== res_search) {
      state.res_search = res_search;
    }
  },

  [constants.SET_SELECTED_BULLET_ID](state, selectedBulletId) {
    state.selectedBulletId = selectedBulletId;
  },

  [constants.SET_IS_REQUEST_STATUS](state, data) {
    state.isRequest = data;
  },
};

const actions = {
  async makeAiSearch({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.makeAiSearch(payload);
    commit(constants.SET_MAKE_AI_SEARCH_SUCCESS, res.data.data);
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  res_search: (state) => {
    let resultvideo = state.res_search.resultvideo;
    resultvideo = resultvideo ? resultvideo : [];
    resultvideo = _.map(resultvideo, (video) => {
      return {
        ...video,
        courseId: video.course_id,
        courseName: video.course_name,
        bookId: video.book_id,
        bookName: video.book_name,
        readingId: video.reading_id,
        readingName: video.reading_name,
        bulletId: video.bullet_id,
        bulletName: video.bullet_name,
        videoId: video.video_id,
        vid: video.vid,
        durationString: video.longtime,
        start: video.begin_time,
        end: video.end_time,
        speed1: video.vpath_x1,
        speed1Dot3: video.vpath_x1,
        speed1Dot5: video.vpath_x1,
        speed2: video.vpath_x1,
      };
    });
    return {
      ...state.res_search,
      resultvideo,
    };
  },

  selectedVideo: (state, getters) => {
    let selectedVideo = _.find(
      getters.res_search.resultvideo,
      (video) => video.bulletId === state.selectedBulletId
    );
    selectedVideo = selectedVideo ? selectedVideo : {};
    return selectedVideo;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
